import { render } from "./Menulink.vue?vue&type=template&id=4e72006e&scoped=true"
import script from "./Menulink.vue?vue&type=script&lang=js"
export * from "./Menulink.vue?vue&type=script&lang=js"

import "./Menulink.vue?vue&type=style&index=0&id=4e72006e&scoped=true&lang=css"

import exportComponent from "/home/forge/tester.cl-planner.com/releases/62689321/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e72006e"]])

export default __exports__